import { useQuery } from 'react-query';

import {
  CorporateSubscriberCirclePartner,
  FeaturedPartner,
  fetchCoporateSubscriberCirclePartners,
  fetchFeaturedPartners,
} from '../utils/backend-api/partners';

export const FEATURED_PARTNERS_KEY = 'FEATURED_PARTNERS';
export const CSC_PARTNERS_KEY = 'CSC_PARTNERS';

export const useFeaturedPartners = () => {
  const { data: featuredPartners, isLoading: isLoadingFeaturedPartners } = useQuery<
    FeaturedPartner[]
  >(FEATURED_PARTNERS_KEY, async () => await fetchFeaturedPartners());
  return { featuredPartners, isLoadingFeaturedPartners };
};

export const useCorporateSubscriberCirclePartners = () => {
  const { data: cscPartners, isLoading: isLoadingCscPartners } = useQuery<
    CorporateSubscriberCirclePartner[]
  >(CSC_PARTNERS_KEY, async () => await fetchCoporateSubscriberCirclePartners());
  return { cscPartners, isLoadingCscPartners };
};
